export enum EnumStorageKeys {
  APP_LANGUAGE = 'unicoSkill@language'
}
